import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { useRestoreEntities } from "./api/use-restore-entities";

interface NotifyMovedToTrashInput {
  entityType: string;
  idList: string[];
  canRestore?: boolean;
}

export function useMovedToTrashToast(): (input: NotifyMovedToTrashInput) => void {
  const { t } = useTranslation("trash");
  const { currentWorkspace }: ReturnType<typeof useCurrentWorkspaceContext> = useCurrentWorkspaceContext();
  const { restoreEntities } = useRestoreEntities(currentWorkspace.id);

  return useCallback(
    ({ entityType, idList, canRestore = true }: NotifyMovedToTrashInput): void => {
      if (idList.length === 0) {
        return;
      }
      toast(t("toast.movedToTrashTitle"), {
        action: canRestore
          ? {
              label: t("toast.undo"),
              onClick: () => {
                void restoreEntities({ entityType, idList }).catch((): void => {
                  toast.error(t("toast.restoreErrorTitle"), { description: t("toast.restoreErrorDescription") });
                });
              },
            }
          : undefined,
      });
    },
    [t, restoreEntities],
  );
}
